import { red } from "../colors/index.js";
const errorColor = (mode)=>'light' === mode ? {
        main: red["600"],
        highContrast: red["700"],
        lowContrast: red["100"]
    } : {
        main: red["500"],
        highContrast: red["100"],
        lowContrast: red["800"]
    };
export { errorColor };

//# sourceMappingURL=error.js.map